import React from "react";
import './Footer.css';


function Footer(props){
    return (
        <div className="footer-wrapper">
            <h6 className="project-owner">Gildo Costa Chauze | 2022</h6>
        </div>
    )
}

export default Footer;